<template>
    <div class="dbcleanup-page">
        <div class="page-head">
            <div class="left">
                <h1>Database Cleanup</h1>
            </div>

        </div>
        <StaleAccountsList ref="StaleAccountsList" />
    </div>
</template>

<script>
    import StaleAccountsList from "@/components/DatabaseCleanup/StaleAccountsList";

    export default {
        name: "DatabaseCleanup",
        components: {
            StaleAccountsList,
        },

        methods: {

        },
        mounted() {}
    };
</script>

<style scoped></style>
